module.exports = __webpack_public_path__ + "static/img/app-icon.68cfb2b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/change-icon/app-icon.png
// module id = wGiD
// module chunks = 118